import { ChangeDetectionStrategy, Component, model, ModelSignal } from '@angular/core';

@Component({
  selector: 'ui-expander-header-base',
  imports: [],
  templateUrl: './expander-header-base.component.html',
  styleUrl: './expander-header-base.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.control-header-expanded]': 'expanded()',
    '(click)': 'toggleExpanded()',
  },
})
export class ExpanderHeaderBaseComponent {
  public expanded: ModelSignal<boolean> = model(true);

  public toggleExpanded(): void {
    this.expanded.set(!this.expanded());
  }
}
